import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GtErrorComponent} from "./gt-error/gt-error.component";
import {GtError2Directive} from "./gt-error/gt-error2.directive";
import {GtErrorDirective} from "./gt-error/gt-error.directive";
import {GtNgDatepickerModule} from "./gt-ng-datepicker/gt-ng-datepicker.module";
import {FormDisabledDirective} from "./form-disabled.directive";
import {ThaiDateTimePipe} from "./thai-datetime.pipe";
import {LoadingComponent} from "./loader/loading.component";
import {LoadingInterceptor} from "./loader/loading-interceptor";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {Http400Interceptor} from "./interceptor/http400-interceptor";
import {Http404Interceptor} from "./interceptor/http404-interceptor";
import {Http409Interceptor} from "./interceptor/http409-interceptor";
import {Http424Interceptor} from "./interceptor/http424-interceptor";
import {Http5xxInterceptor} from "./interceptor/http5xx-interceptor";
import {NgbdToastGlobalModule} from "./toast/toast-global.module";
import {DialogModule} from "./dialog/dialog.module";
import {AppFileUploadModule} from "./app-file-upload/app-file-upload.module";
import {AppHeaderComponent} from "./app-header/app-header.component";
import {RouterModule} from "@angular/router";
import {CustomErrorDirective} from "./custom-error.directive";
import {NovalidateInputDirective} from "./novalidateinput.directive";
import {HttpGetUuidInterceptor} from "./interceptor/http-get-uuid-interceptor";
import {Http401Interceptor} from "./interceptor/http401-interceptor";
import {NgbdSortableHeader} from "./sortable.directive";
import {NetworkUnstableComponent} from "./network-unstable/network-unstable.component";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";


@NgModule({
  declarations: [
    GtErrorComponent,
    GtError2Directive,
    GtErrorDirective,
    FormDisabledDirective,
    NovalidateInputDirective,
    ThaiDateTimePipe,
    LoadingComponent,
    AppHeaderComponent,
    CustomErrorDirective,
    NgbdSortableHeader,
    NetworkUnstableComponent
  ],
  exports: [
    NgbModule,
    NgbdToastGlobalModule,
    DialogModule,
    AppFileUploadModule,
    GtErrorComponent,
    GtError2Directive,
    GtErrorDirective,
    GtNgDatepickerModule,
    FormDisabledDirective,
    NovalidateInputDirective,
    ThaiDateTimePipe,
    LoadingComponent,
    AppHeaderComponent,
    CustomErrorDirective,
    NgbdSortableHeader,
    NetworkUnstableComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    GtNgDatepickerModule,
    NgbdToastGlobalModule,
    DialogModule,
    AppFileUploadModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Http400Interceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Http401Interceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Http404Interceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Http409Interceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Http424Interceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Http5xxInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpGetUuidInterceptor,
      multi: true
    },
    {
      provide: 'localStorage',
      useValue: window.localStorage
    },
  ]
})
export class SharedCommonModule {
}
